import { Spin, Tag } from "antd";
import React, { useMemo } from "react";
import MediTable from "components/Custom";
import ActionButtons from "components/ActionButtons";
import { GIOITHIEU_STT_OPTIONS } from "constants";
import { useSelector } from "react-redux";

const CHUNG_CHI_LABEL = { true: "Đã có", false: "Chưa có" };

const DanhSachHoSo = ({ HoSoUngVienList, onOpenDetail, onViewDetail, onDelete, loading }) => {
  const { ThietLapTuyenDungList } = useSelector((state) => state.tuyenDung);
  const { danhMucChuyenMonListSetting } = useSelector((state) => state.chuyenMonCategory);
  const { branchList } = useSelector((state) => state.sangKienYTuong);

  const tableColumns = useMemo(
    () => [
      {
        title: "STT",
        align: "center",
        width: 50,
        render: (_, __, index) => index + 1,
      },
      {
        title: "Mã giới thiệu",
        dataIndex: "maGioiThieu",
      },
      {
        title: "Tên người giới thiệu",
        dataIndex: "tenNguoiGioiThieu",
      },
      {
        title: "SĐT người giới thiệu",
        dataIndex: "phoneNguoiGioiThieu",
      },
      {
        title: "Tên ứng viên",
        dataIndex: "tenUngVien",
        render: (txt, record) => (
          <div
            style={{ cursor: "pointer", fontWeight: "bold" }}
            onClick={() => onViewDetail(record?.id)}
            onMouseEnter={(e) => { e.target.style.color = "blue"; e.target.style.textDecoration = "underline"; }}
            onMouseLeave={(e) => { e.target.style.color = "initial"; e.target.style.textDecoration = "none"; }}
          >
            {txt}
          </div>
        ),
      },
      {
        title: "Mã hồ sơ ứng viên",
        dataIndex: "maHoSoUV",
        editable: true,
      },
      {
        title: "SĐT ứng viên",
        dataIndex: "phoneUngVien",
      },
      {
        title: "Vị trí ứng tuyển",
        dataIndex: "viTriUngTuyenId",
        render: (id) => {
          const item = (ThietLapTuyenDungList || []).find((t) => t.id === id);
          return item?.tenThietLap || null;
        },
      },
      {
        title: "Chuyên môn",
        dataIndex: "chuyenMonId",
        render: (id) => {
          const item = (danhMucChuyenMonListSetting || []).find((m) => m.id === id);
          return item?.name || null;
        },
      },
      {
        title: "Chứng chỉ hành nghề",
        dataIndex: "chungChiHanhNghe",
        width: 120,
        align: "center",
        render: (val) => CHUNG_CHI_LABEL[val] ?? null,
      },
      {
        title: "Cơ sở muốn làm việc",
        dataIndex: "tenChiNhanhUngTuyen",
        width: 150,
        render: (id) => {
          const item = (branchList || []).find((b) => (b.value ?? b.id) === id);
          return item?.label ?? item?.name ?? id ?? null;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "trangThai",
        width: 150,
        align: "center",
        render: (value) => {
          const opt = GIOITHIEU_STT_OPTIONS.find((o) => o.id === value);
          return opt ? <Tag color={opt.color}>{opt.name}</Tag> : null;
        },
      },
      {
        fixed: "right",
        align: "center",
        width: 100,
        render: (_, record) => (
          <div style={{ display: "flex", alignItems: "center", gap: 4, justifyContent: "center" }}>
            <ActionButtons
              record={record}
              editable={false}
              disabledEdit={record.trangThai !== 1 && record.trangThai !== null}
              disabledDelete={record.trangThai !== 1 && record.trangThai !== null}
              edit={() => onOpenDetail(record.id)}
              handleDelete={() => onDelete(record.id)}
            />
          </div>
        ),
      },
    ],
    [onDelete, onOpenDetail, onViewDetail, ThietLapTuyenDungList, danhMucChuyenMonListSetting, branchList]
  );

  return (
    <Spin tip="Đang tải..." spinning={loading}>
      <MediTable
        tableColumns={tableColumns}
        dataSource={HoSoUngVienList}
        scroll={{ x: "max-content" }}
        rowKey={(item) => item?.id}
      />
    </Spin>
  );
};

export default DanhSachHoSo;
